import { inject, Injectable } from '@angular/core';
import { ConnectionHttpService, HttpService, Store } from '@softline/core';
import { lastValueFrom, map } from 'rxjs';
import { SOFTLINE_API_PMS_STEMPELTERMINAL_STEMPELN } from '../stempel-terminal.api';
import { StempelBody } from '../types/stempel-body';
import { StempelResult } from '../types/stempel-result';

@Injectable()
export class StempelApiRepository {
  private readonly service = new ConnectionHttpService(
    inject(Store),
    inject(HttpService)
  );

  async save(stempel: StempelBody[]): Promise<StempelResult> {
    return lastValueFrom(
      this.service
        .create<
          StempelBody[],
          StempelResult
        >({ path: SOFTLINE_API_PMS_STEMPELTERMINAL_STEMPELN }, stempel)
        .pipe(map((response) => (response as any).result)) //TODO: remove any
    );
  }
}
